import { NavigateFunction } from 'react-router-dom';

import * as util from './util';

/**
 * 로그인이 필요한 화면으로 보내는 공통 처리.
 *
 * 이 프로젝트는 로그인 화면으로 보내는 지점이 30곳쯤 되는데, 대부분
 * `navigate('../Login')` 처럼 **가려던 곳을 버리고** 보냈다. 그래서 로그인을 마치면
 * 원래 누른 메뉴가 아니라 항상 홈으로 떨어졌다.
 *
 * 목적지는 react-router 의 location.state.from 으로 넘긴다.
 * 받는 쪽은 pages/Login.tsx 의 redirectTo() 하나뿐이다.
 * (RequireLogin 라우트 가드도 같은 키를 쓴다 — 두 경로가 같은 규약을 공유한다.)
 */

/** 로그인 여부 판정. 프로젝트의 다른 화면들과 같은 기준(userCusID)을 쓴다. */
export const isLoggedIn = (): boolean =>
  util.strNull(window.localStorage.userCusID) !== '';

/**
 * 로그인했으면 target 으로, 아니면 로그인 화면으로 보내되 target 을 기억시킨다.
 *
 * @param navigate useNavigate() 결과
 * @param target   원래 가려던 경로. 절대경로('/care')로 준다 —
 *                 상대경로는 로그인 후 복귀할 때 기준 라우트가 달라져 엉뚱한 곳으로 간다.
 */
export const goOrLogin = (navigate: NavigateFunction, target: string) => {
  if (isLoggedIn()) {
    navigate(target);
    return;
  }
  navigate('/login', { state: { from: target } });
};

/**
 * 화면 안에서 '로그인 하기' 버튼을 눌렀을 때처럼, 지금 보고 있는 화면으로
 * 되돌아와야 하는 경우.
 *
 * @param here 현재 경로. 보통 `location.pathname + location.search`.
 */
export const goLoginAndReturn = (navigate: NavigateFunction, here: string) => {
  navigate('/login', { state: { from: here } });
};
